import { type ReactNode, useState } from 'react';
import { cn } from '@shared/utils';

let timerId: NodeJS.Timeout;

export enum TooltipDirectionEnum {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
}
type DirectionType = TooltipDirectionEnum | `${TooltipDirectionEnum}`;

interface TooltipProps {
  content: string;
  direction?: DirectionType;
  children: ReactNode;
}

export const Tooltip = (props: TooltipProps) => {
  const [active, setActive] = useState<boolean>(false);

  return (
    <div
      className='relative inline-block'
      onMouseEnter={() => (timerId = setTimeout(() => setActive(true), 300))}
      onMouseLeave={() => (clearInterval(timerId), setActive(false))}
    >
      {props.children}
      {active && (
        <div
          className={cn(
            'absolute left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded bg-black p-[6px] text-sm leading-[1] text-white',
            'before:pointer-events-none before:absolute before:left-1/2 before:-ml-[6px] before:h-0 before:w-0 before:border-[6px] before:border-transparent before:content-["_"]',
            (!props.direction || props.direction === TooltipDirectionEnum.Top) && ['-top-[30px]', 'before:top-full before:border-t-black'],
            props.direction === TooltipDirectionEnum.Right && [
              'left-[calc(100%+60px)] top-1/2 -translate-y-1/2',
              'before:-left-[6px] before:top-1/2 before:-translate-y-1/2 before:border-r-black',
            ],
            props.direction === TooltipDirectionEnum.Bottom && ['-bottom-[30px]', 'before:bottom-full before:border-b-black'],
            props.direction === TooltipDirectionEnum.Left && [
              'left-auto right-[calc(100%+60px)] top-1/2 -translate-y-1/2',
              'before:-right-[12px] before:left-auto before:top-1/2 before:-translate-y-1/2 before:border-l-black',
            ],
          )}
        >
          {props.content}
        </div>
      )}
    </div>
  );
};
